<p>kamona-message-modal works!</p>
